export const top_common = () => {
   //let total_num = $('.section--member .column4_item_wrapper').length;
   //console.log('total_num:'+total_num);

   function shuffleContent(container) {
      var content = container.find("> *");
      var total = content.length;
      content.each(function() {
        content.eq(Math.floor(Math.random() * total)).prependTo(container);
      });
    }

    shuffleContent($(".member_wrapper .column4_contents"));

    /*
    let block_num = 6;
    $('.member_more').click(function () {
       $('.section--member .column4_item_wrapper:lt('+block_num+')').css('display','block');//lt(n)n番目以前の要素すべて
       block_num += 3;
       if(total_num < block_num) {
         $('.member_more').css('display','none');
          console.log("これ位以上ありませんよ。");
       }
    })
    */
   let block_num = 6;
   $('.member_more').click(function () {
      $('.section--member .column4_item_wrapper:nth-child(n+7)').css('display','block');//lt(n)n番目以前の要素すべて
        $('.member_more').css('display','none');
   })

  }//top_common

export const top_pc = () => {
   let $top_kv_slider = $('.mvSlideWrapper');
   $top_kv_slider.slick ({
     arrows:false,
     dots:true,
     //pauseOnHover: false,
     //pauseOnFocus: false,
     //pauseOnDotsHover: true,
     autoplay:true,
     autoplaySpeed:2000,
     speed:1200,
     fade:true,
     waitForAnimate:false
     //pauseOnHover:true,
     //pauseOnFocus:false,
     //pauseOnDotsHover:false,
     //prevArrow: '<div class="slider-arrow slider-arrow-left"></div>',
     //nextArrow: '<div class="slider-arrow slider-arrow-right"></div>',
   });

   let $top_slider = $('.mvSlideWrapper');
/*
   let current_slide;
    $top_slider.on('beforeChange', function(slick, currentSlide){
      current_slide = $top_slider.slick('slickCurrentSlide');
      console.log(current_slide);
    });
*/

   $top_slider.on('mouseover', function () {
     $top_slider.slick('slickPause');
   })
   .on('mouseout', function () {
     //$('.home .slick-dots li button:before').css('opacity','0.25');
     //$top_slider.slick('setPosition');
     //$top_slider.slick('slickGoTo', current_slide, true);
     $top_slider.slick('play');
   });


   let $top_banner_slider = $('.bannerSliderWrapper');
   $top_banner_slider.slick ({
     arrows:false,
     dots:true,
     //pauseOnHover: false,
     //pauseOnFocus: false,
     //pauseOnDotsHover: true,
     autoplay:true,
     autoplaySpeed:2000,
     speed:1200,
     fade:true,
     waitForAnimate:false
     //pauseOnHover:true,
     //pauseOnFocus:false,
     //pauseOnDotsHover:false,
     //prevArrow: '<div class="slider-arrow slider-arrow-left"></div>',
     //nextArrow: '<div class="slider-arrow slider-arrow-right"></div>',
   });

   $top_banner_slider.on('mouseover', function () {
      $top_banner_slider.slick('slickPause');
    })
    .on('mouseout', function () {
      $top_banner_slider.slick('play');
    });
 


}

export const top_sp = () => {
   let $top_kv_slider = $('.mvSlideWrapper');
   $top_kv_slider.slick ({
     arrows:false,
     dots:true,
     autoplay:true,
     autoplaySpeed:2000,
     speed:1200,
     fade:true,
     //pauseOnFocus:false,
    // pauseOnHover:false,
     //pauseOnDotsHover:false,
     //prevArrow: '<div class="slider-arrow slider-arrow-left"></div>',
     //nextArrow: '<div class="slider-arrow slider-arrow-right"></div>',
   });


   let $top_banner_slider = $('.bannerSliderWrapper');
   $top_banner_slider.slick ({
     arrows:true,
     dots:true,
     autoplay:true,
     autoplaySpeed:2000,
     speed:1200,
     waitForAnimate:false
     fade:true,
     prevArrow: '<div class="slider-arrow slider-arrow-left spOnly"></div>',
     nextArrow: '<div class="slider-arrow slider-arrow-right spOnly"></div>',
   });
}